<template>
  <v-footer>
    <v-col
      class="text-center"
      cols="12"
    >
      {{ new Date().getFullYear() }} — <strong> Social Fundraiser</strong>
    </v-col>
  </v-footer>
</template>
<script>
export default {
	name: "Footer"
}
</script>

<style>

</style>